import React, { useState, Fragment } from 'react';
import {
  Col,
  Row,
  Form,
  Button,
  Container,
  InputGroup,
  Alert,
  Spinner
} from '@themesberg/react-bootstrap';
import { FaCar } from 'react-icons/fa';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import { useParams } from 'react-router-dom';

import LOGO from '../../assets/img/logo.jpg';
import { get } from '../../services/back.service';

const Validation = () => {
  const { id } = useParams();
  const [plate, setPlate] = useState('');
  const [urlFile, setUrlFile] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  const [inProcess, setInProcess] = useState(false);
  const [showPdf, setShowPdf] = useState(false);
  const [messageAlert, setMessageAlert] = useState('');

  const submit = async () => {
    setInProcess(true);
    const url = `/peritaje/verifyinpection/`;
    const response = await get(url, {}, { id, plate });
    if (response.success) {
      setShowAlert(false);
      setShowPdf(true);
      setUrlFile(response.data.urlAws);
    } else {
      setShowPdf(false);
      setShowAlert(true);
      setMessageAlert('Peritaje invalido');
    }
    setInProcess(false);
  };

  const validarEnter = (e) => {
    if (e.keyCode === 13) submit();
  };

  return (
    <Fragment>
      <Container>
        <Row className="justify-content-center form-bg-image">
          <Col xs={12} className="d-flex align-items-center justify-content-center">
            <div className="bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-80 fmxw-500">
              <div className="text-center text-md-center mb-4 mt-md-0">
                <img src={LOGO} width={250} alt="IntegraMotor - Centro integral automotor" />
                <h3 className="mb-0 mt-4 fs-6 fw-bold">Iniciar sesión</h3>
              </div>
              {showAlert && <Alert variant="danger">{messageAlert}</Alert>}
              <Form className="mt-4">
                <Form.Group id="email" className="mb-4">
                  <Form.Label>PLACA</Form.Label>
                  <InputGroup>
                    <InputGroup.Text>
                      <FaCar />
                    </InputGroup.Text>
                    <Form.Control
                      autoFocus
                      required
                      type="text"
                      onKeyUp={validarEnter}
                      onChange={(e) => setPlate(e.target.value)}
                      value={plate}
                      placeholder="ABC123"
                    />
                  </InputGroup>
                </Form.Group>
                {inProcess ? (
                  <div className="d-flex justify-content-center align-items-center">
                    <Spinner animation="border" role="status" variant="danger" />
                  </div>
                ) : (
                  <Button onClick={submit} className="w-100" disabled={inProcess}>
                    Consultar
                  </Button>
                )}
              </Form>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            {showPdf && (
              <div style={{ border: '1px solid rgba(0, 0, 0, 0.3)', height: '500px' }}>
                <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                  <Viewer fileUrl={urlFile} />
                </Worker>
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default Validation;
